
import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'
import { namespace } from 'vuex-class'

import { Note } from '@/lib/dnote'
const dnote = namespace('dnote')

const Props = Vue.extend({
  props: {
    note: Object as PropType<Note>,
  }
})

@Component({
  name: 'note-actions',
})
export default class NoteActions extends Props {
  /* eslint-disable no-unused-vars */
  @dnote.Mutation
  setCurrentNote!: (note: Note | null) => void

  @dnote.Mutation
  setShowNoteEditDialog!: (show: boolean) => void

  @dnote.Action
  removeNote!: (note: Note) => void
  /* eslint-enable no-unused-vars */

  show() {
    this.setCurrentNote(this.note)
    this.setShowNoteEditDialog(true)
  }
}
